/**
 * Utility functions for handling files with the new nested structure
 */

/**
 * Check if an article has a file (either new nested structure or old URL structure)
 * @param {object} article - The article object
 * @returns {boolean} - True if article has a file
 */
export const hasFile = (article) => {
  if (!article) return false;
  return !!(article.file || article.fileLink || article.pdfLink);
};

/**
 * Get the file URL for an article (prioritizes new nested structure)
 * @param {object} article - The article object
 * @returns {string} - The file URL
 */
export const getFileUrl = (article) => {
  if (!article) return '';

  // New nested structure - use your domain with friendly URL if available
  if (article.file && article.file.data) {
    if (article.friendlyUrl) {
      return `https://aimjhm.com/files/${article.friendlyUrl}`;
    }
    return `https://aimjhm.com/files?id=${article.id}`;
  }

  // Fallback to old URL structure
  return article.fileLink || article.pdfLink || '';
};

/**
 * Get file information for display
 * @param {object} article - The article object
 * @returns {object} - File info object
 */
export const getFileInfo = (article) => {
  if (!article) return null;
  
  if (article.file) {
    return {
      name: article.file.name,
      size: article.file.size,
      type: article.file.type,
      url: getFileUrl(article),
      isMigrated: true
    };
  }
  
  return {
    name: article.fileLink ? article.fileLink.split('/').pop() : 'Unknown',
    size: null,
    type: null,
    url: getFileUrl(article),
    isMigrated: false
  };
};

/**
 * Format file size for display
 * @param {number} bytes - File size in bytes
 * @returns {string} - Formatted file size
 */
export const formatFileSize = (bytes) => {
  if (!bytes) return 'Unknown size';
  
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  return Math.round(bytes / Math.pow(1024, i) * 100) / 100 + ' ' + sizes[i];
};
